import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";

export type HolidayResource = {
	name: string;
	date: string;
};

export const holidaysKey = (yasumiProviderId: Id, year: number) => ["holidays", `${yasumiProviderId}`, `${year}`];

export const holidayService = {
	holidaysKey,
	holidays: (yasumiProviderId: Id, year: number) =>
		axios.get<LaravelResponse<HolidayResource[]>>(keyToUrl(holidaysKey(yasumiProviderId, year))),
};
